import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { EEARType, EEARTypeHelper } from 'src/app/model/enum/reporting/eear-type.enum';

@Component({
    selector: 'paetep-eear-info-modal',
    templateUrl: './eear-info-modal.component.html',
    styleUrls: ['./eear-info-modal.component.scss']
})
export class EearInfoModalComponent implements OnInit {
    @Input() eearType: EEARType = EEARType.INDIVIDUALS;

    eearTypes = EEARType;

    constructor(
        public activeModal: NgbActiveModal) { }

    ngOnInit(): void {
    }

    getEEARTypeName(){
        return EEARTypeHelper.getEEARTypeLabel(this.eearType);
    }

}
